import type { ReactElement } from 'react';
import { useField } from '@ff-it/form';
import { Box, Button, PopoverRoot, PopoverTrigger, PopoverPopup } from '@ff-it/ui';
import useSWR from 'swr';

type ResolvedPO = { client_po_number: string };

export function POResolution({ invoiceId }: { invoiceId: number }): ReactElement | null {
  const {
    input: { value, onChange },
  } = useField<string>('client_po_number', { subscription: { value: true } });
  const { data, error, isValidating } = useSWR<ResolvedPO>(
    { url: `invoicing/income/${invoiceId}/resolve_po_number/`, method: 'GET' },
    { revalidateOnMount: true },
  );
  const resolvedPO = data?.client_po_number;

  if (error || isValidating || !resolvedPO || resolvedPO === value) return null;

  return (
    <PopoverRoot>
      <PopoverTrigger>
        <Button type="button" variant="ghost" size="xs" icon="arrows-rotate" aria-label="Current PO numbers" />
      </PopoverTrigger>
      <PopoverPopup placement="bottom-end">
        <Box p="3" maxWidth="20rem" fontSize="sm" style={{ overflowWrap: 'anywhere' }}>
          <Box fontWeight="semibold" mb="2">
            Current PO numbers
          </Box>
          <Box mb="2" fontWeight="semibold">
            {resolvedPO}
          </Box>
          <Button type="button" size="sm" variant="secondary" icon="arrows-rotate" onClick={() => onChange(resolvedPO)}>
            Sync
          </Button>
        </Box>
      </PopoverPopup>
    </PopoverRoot>
  );
}
